import { useMutation, useQueryClient } from 'react-query';

import { updateHub as update } from 'api/traps/Hubs/updateHub';

const useUpdateHub = () => {
  const queryClient = useQueryClient();
  const {
    isSuccess,
    mutate: updateHub,
    isLoading,
  } = useMutation(update, {
    onSuccess: () => {
      queryClient.invalidateQueries(['useGetHub']);
    },
  });

  return {
    isSuccess,
    updateHub,
    isLoading,
  };
};

export default useUpdateHub;
